import { Box, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { CustomBackButton } from '../common-components/CustomButton'
import { useHistory } from 'react-router-dom'

export const PortalTabHeader: React.FC<{
  header: React.ReactNode | string
  description?: React.ReactNode | string
  actionButton?: React.ReactNode
  backButtonLabel?: React.ReactNode | string
  backButtonHref?: string
}> = ({
  header,
  actionButton,
  description,
  backButtonLabel,
  backButtonHref
}) => {
  const history = useHistory()
  const isBackButton = backButtonLabel != null

  return (
    <>
      <Typography variant='h1'>
        {header}
      </Typography>
      {(header != null || actionButton != null) &&
        <Grid container sx={{ mb: '4px' }} justifyContent='space-between' wrap='nowrap'>
          <Grid item xs={8}>
            <Typography>
              {description}
            </Typography>
          </Grid>

          <Grid item xs={4} container justifyContent='flex-end'>
            <Grid item>
              {actionButton}
            </Grid>
          </Grid>
        </Grid>}
      <Divider sx={{ mb: isBackButton ? '16px' : '12px' }} />
      {isBackButton &&
        <Box sx={{ mb: '12px' }}>
          <CustomBackButton
            onClick={e => {
              if (typeof backButtonHref === 'string') {
                history.push(backButtonHref)
              } else {
                history.goBack()
              }
            }}
          >
            {backButtonLabel}
          </CustomBackButton>
        </Box>}
    </>
  )
}
